import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  Button,
  Checkbox,
  ColumnLayout,
  Container,
  ContentLayout,
  Flashbar,
  FormField,
  Header,
  HelpPanel,
  Input,
  Link,
  Modal,
  SideNavigation,
  SpaceBetween,
  Spinner,
  SplitPanel,
  StatusIndicator,
} from "@cloudscape-design/components";
// import { Navigation } from "../../../components/app/Navigation";
import Icon from "@cloudscape-design/components/icon";
// import { dataUnit } from "../../dashboard/data";
// import { Grid,  } from '@cloudscape-design/components';
import DetailDashboard from "./component/DetailDashboard";
import { Navigation } from "../../../components/app/Navigation";
import { deleteVehicle, updateVehicle } from "../../../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { VehicleMasterTable } from "../w_vehicles/data";
import { listVehicles } from "../../../graphql/queries";
import { ListVehiclesQueryVariables } from "../../../API";
import DetailOverview from "./component/DetailOverview";
import { fetchAuthSession } from "aws-amplify/auth";

// get user belong to what group and make it into string
async function checkUserGroup() {
  try {
    const { tokens } = await fetchAuthSession();
    // Normalize user groups to be an array of strings
    const groups = tokens?.accessToken.payload["cognito:groups"];
    if (Array.isArray(groups)) {
      return groups as string[]; // Safe to cast as string[]
    } else if (typeof groups === "string") {
      return [groups]; // Convert a single string to an array
    } else {
      return []; // Default to an empty array if not an array or string
    }
  } catch (error) {
    console.error("Error fetching user groups:", error);
    return []; // Default to an empty array in case of an error
  }
}

async function checkCurrentUser(): Promise<{
  username: string;
  email: string | null;
}> {
  try {
    const { tokens } = await fetchAuthSession();
    // extract the user's information from the accessToken or idTOken
    const currentUser = tokens?.idToken?.payload || tokens?.accessToken.payload;

    if (currentUser) {
      const username =
        typeof currentUser["cognito:username"] === "string"
          ? currentUser["cognito:username"]
          : ""; //fallback if username is empty

      const email =
        typeof currentUser.email === "string" ? currentUser.email : null;
      return { username, email };
    } else {
      console.error("No User Infromation found.");
      return { username: "", email: null };
    }
  } catch (error) {
    console.error("Error fetching current user information:", error);
    return { username: "", email: null };
  }
}

interface FlashbarItem {
  type: "info" | "warning" | "error" | "success"; // Adjust according to your requirements
  dismissible: boolean;
  dismissLabel: string;
  onDismiss: () => void;
  content: React.ReactNode;
  id: string;
}

async function deleteVehicleApi(id: string) {
  try {
    const client = generateClient();
    await client.graphql({
      query: deleteVehicle,
      authMode: "userPool",
      variables: {
        input: {
          id,
        },
      },
    });
  } catch (err) {
    console.log("Error deleting vehicle: ", err);
  }
}

async function updateVehicleApi(
  id: string,
  vehiclecode: string,
  typevehicle: string,
  location: string,
  status: boolean,
  category: string
) {
  try {
    const client = generateClient();
    await client.graphql({
      query: updateVehicle,
      authMode: "userPool",
      variables: {
        input: {
          id: id,
          vehiclecode: vehiclecode,
          typevehicle: typevehicle,
          location: location,
          status: status,
          category: category,
        },
      },
    });
  } catch (err) {
    console.log("Error updating vehicle: ", err);
  }
}

const VehicleDetail: React.FC = () => {
  const [activeHref, setActiveHref] = React.useState("/vehicles");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const { name } = useParams<{ name: string }>();
  const [isModalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [isModalUpdateVisible, setModalUpdateVisible] = useState(false);
  const [itemsFlashbar, setItemsFlashbar] = useState<FlashbarItem[]>([]);
  const [itemsFlashbar2, setItemsFlashbar2] = useState<FlashbarItem[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  const navigate = useNavigate();

  let { VehicleCode } = useParams();

  const [vehicleList, setVehicleList] = useState<VehicleMasterTable[]>([]);

  const vehicleIdRef = useRef<string | null>(null);

  const [vehicleCode, setVehicleCode] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vehicleCategory, setVehicleCategory] = useState("");
  const [vehicleLocation, setVehicleLocation] = useState("");
  const [vehicleStatus, setVehicleStatus] = useState(false);
  const [checked, setChecked] = useState(false);
  const [userGroups, setUserGroups] = useState<string[]>([]);
  const [currentUser, setCurrentUser] = useState<string>("");
  const [currentUserEmail, setCurrentUserEmail] = useState<string>("");



  // TimeStamp for log Format
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; 
  const day = now.getDate();
  const hours = String(now.getHours()).padStart(2, "0"); 
  const minutes = String(now.getMinutes()).padStart(2, "0"); 
  const seconds = String(now.getSeconds()).padStart(2, "0"); 
  const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  // call all the necessary funtion on page load , init fetch user group
  useEffect(() => {
    async function initialize() {
      const groups = await checkUserGroup();
      const user = await checkCurrentUser();
      setCurrentUser(user.username);
      setCurrentUserEmail(user.email ?? "");
      setUserGroups(groups);
      fetchVehicle();
    }
    initialize();
  }, []);

  const fetchVehicle = async (limit = 100) => {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allVehicles: VehicleMasterTable[] = [];

      do {
        const variables: ListVehiclesQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listVehicles,
          authMode: "userPool",
          variables,
        });

        const vehicles = response.data.listVehicles.items;
        nextToken = response.data.listVehicles.nextToken ?? null;

        const newVehicles: VehicleMasterTable[] = vehicles.map(
          (vehicle: any) => ({
            id: vehicle.id,
            VehicleCode: vehicle.vehiclecode ?? "",
            TypeVehicle: vehicle.typevehicle ?? "",
            Location: vehicle.location ?? "",
            Category: vehicle.category ?? "",
            Status: Boolean(vehicle.status),
            Timestamps: vehicle.updatedAt ?? "",
          })
        );

        allVehicles = [...allVehicles, ...newVehicles];
      } while (nextToken);

      const filteredVehicles = allVehicles.filter(
        (vehicle) => vehicle.VehicleCode === VehicleCode
      );
      setVehicleList(filteredVehicles);
      setIsLoading(false);

      if (filteredVehicles.length > 0) {
        const timestamp = new Date(filteredVehicles[0].Timestamps);
        const formattedTimestamp = timestamp.toLocaleString();
        setItemsFlashbar([
          {
            type: "info",
            dismissible: true,
            dismissLabel: "Dismiss message",
            onDismiss: () => setItemsFlashbar([]),
            content: `Last Update Data Received: ${formattedTimestamp}`,
            id: "message_1",
          },
        ]);
      } else {
        setItemsFlashbar([
          {
            type: "info",
            dismissible: true,
            dismissLabel: "Dismiss message",
            onDismiss: () => setItemsFlashbar([]),
            content: "No vehicle data found.",
            id: "message_2",
          },
        ]);
      }
    } catch (err) {
      console.log("Error fetching vehicles: ", err);
      setItemsFlashbar([
        {
          type: "error",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar([]),
          content: "Error fetching vehicle data.",
          id: "message_3",
        },
      ]);
    }
  };

  const handleDelete = async () => {
    setModalDeleteVisible(false);
    if (vehicleList.length > 0) {
      const vehicleIdToDelete = vehicleList[0].id;
      await deleteVehicleApi(vehicleIdToDelete);
      // transaction log
      console.log(
        `Vehicle Detail Transaction Log (Delete Item):
      Vehicle ID : ${vehicleList[0].id}
      Vehicle Code : ${vehicleList[0].VehicleCode}
      User Group : ${userGroups}
      User : ${currentUser}
      user Email : ${currentUserEmail}
      Timestamp : ${timestamp}`
      );
      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "Vehicle successfully deleted.",
          id: "message_4",
        },
      ]);
      navigate("/vehicles");
    }
  };
  const handleUpdate = async () => {
    setModalUpdateVisible(false);
    if (vehicleList.length > 0) {
      const vehicleIdToUpdate = vehicleList[0].id;
      await updateVehicleApi(
        vehicleIdToUpdate,
        vehicleCode,
        vehicleType,
        vehicleLocation,
        vehicleStatus,
        vehicleCategory
      );
      // for transaction logs
      console.log(
        `Vehicle Detail Transaction Log (Update Item):
      Vehicle ID : ${vehicleList[0].id}
      Vehicle Code : ${vehicleCode} 
      User Group : ${userGroups}
      User : ${currentUser}
      User Email : ${currentUserEmail}
      Timestamp : ${timestamp}`
      );
      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "Vehicle successfully updated.",
          id: "message_5",
        },
      ]);
      fetchVehicle(); // Refresh the vehicle list after update
    }
  };

  const handleEditButtonClick = () => {
    setModalUpdateVisible(true);
    if (vehicleList.length > 0) {
      const vehicle = vehicleList[0];
      setVehicleCode(vehicle.VehicleCode);
      setVehicleType(vehicle.TypeVehicle);
      setVehicleCategory(vehicle.Category);
      setVehicleLocation(vehicle.Location);
      setVehicleStatus(vehicle.Status);
      setModalUpdateVisible(true);
    }
  };

  const handleDeleteCOnfirmation = () => {
    setModalDeleteVisible(true);
  };

  const isButtonDisabled =
    userGroups.includes("user_guest") || userGroups.includes("operator");
  const isButtonEditDisabled = userGroups.includes("user_guest");

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles",
              },
              // {
              //   text: "Vehicle Summary",
              //   href: "/vehicles",
              // },
              {
                text: `Unit : ${VehicleCode}`,
                href: `/vehicles/: ${VehicleCode}`,
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
            // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title WWWW (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                actions={
                  <SpaceBetween size='s' direction='horizontal'>
                    <Button
                      onClick={handleEditButtonClick}
                      disabled={isButtonEditDisabled}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={handleDeleteCOnfirmation}
                      disabled={isButtonDisabled}
                    >
                      Delete
                    </Button>
                  </SpaceBetween>
                }
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/vehicles" ? `Unit :  ${VehicleCode}` : ""}
              </Header>
            }
          >
            <div
              className='contentPlaceholder'
              style={{ marginTop: isLoading ? "120px" : "0px" }}
            >
              {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading vehicle data...</Box>
                </Box>
              ) : (
                <Container>
                  <Flashbar items={itemsFlashbar2} />
                  <ColumnLayout columns={2} minColumnWidth={500}>
                    <div>
                      <div>
                        <h1>Detail Unit</h1>
                        <h3>{VehicleCode}</h3>
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <Flashbar items={itemsFlashbar} />
                      </div>
                      {vehicleList.length > 0 ? (
                        vehicleList.map((vehicle) => (
                          <ColumnLayout
                            key={vehicle.id}
                            borders='horizontal'
                            columns={2}
                          >
                            <div>Vehicle ID</div>
                            <div style={{ fontWeight: "bold" }}>
                              {vehicle.id}
                            </div>
                            <div>Vehicle Type</div>
                            <div style={{ fontWeight: "bold" }}>
                              {vehicle.TypeVehicle}
                            </div>
                            <div>Vehicle Code</div>
                            <div style={{ fontWeight: "bold" }}>
                              {vehicle.VehicleCode}
                            </div>
                            <div>Vehicle Category</div>
                            <div style={{ fontWeight: "bold" }}>
                              {vehicle.Category}
                            </div>
                            <div>Vehicle Location</div>
                            <div>{vehicle.Location}</div>
                            <div>Vehicle Odometer</div>
                            <div>49.567 KM</div>
                            <div>Vehicle Status</div>
                            <div>
                              <StatusIndicator
                                type={vehicle.Status ? "success" : "error"}
                              >
                                {vehicle.Status ? "Active" : "Deactivated"}
                              </StatusIndicator>
                            </div>
                            <div>Current Alarm</div>
                            <div>
                              <StatusIndicator type='warning'>
                                (1) No GPS Signal
                              </StatusIndicator>
                            </div>
                          </ColumnLayout>
                        ))
                      ) : (
                        <div>No vehicle data found.</div>
                      )}
                    </div>

                    <DetailOverview />
                  </ColumnLayout>
                </Container>
              )}
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
      <Modal
        onDismiss={() => setModalDeleteVisible(false)}
        visible={isModalDeleteVisible}
        closeAriaLabel='Close modal'
        header='Confirm Delete'
        footer={
          <SpaceBetween direction='horizontal' size='s'>
            <Button variant='link' onClick={() => setModalDeleteVisible(false)}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleDelete}>
              Confirm
            </Button>
          </SpaceBetween>
        }
      >
        <p>Are you sure you want to delete this Unit?</p>
      </Modal>
      <Modal
        onDismiss={() => setModalUpdateVisible(false)}
        visible={isModalUpdateVisible}
        footer={
          <Box float='right'>
            <SpaceBetween direction='horizontal' size='xs'>
              <Button
                variant='link'
                onClick={() => setModalUpdateVisible(false)}
              >
                Cancel
              </Button>
              <Button variant='primary' onClick={handleUpdate}>
                Submit
              </Button>
            </SpaceBetween>
          </Box>
        }
        header='Edit Vehicle'
      >
        <Container>
        <SpaceBetween direction='vertical' size='l'>
            <FormField label='Vehicle Code'>
              <Input
                value={vehicleCode}
                onChange={({ detail }) => setVehicleCode(detail.value)}
              />
            </FormField>
            <FormField label='Vehicle Type'>
              <Input
                value={vehicleType}
                onChange={({ detail }) => setVehicleType(detail.value)}
              />
            </FormField>
            <FormField label='Category'>
              <Input
                value={vehicleCategory}
                onChange={({ detail }) => setVehicleCategory(detail.value)}
              />
            </FormField>
            <FormField label='Location'>
              <Input
                value={vehicleLocation}
                onChange={({ detail }) => setVehicleLocation(detail.value)}
              />
            </FormField>
            <FormField label='Status'>
              <Checkbox
                checked={vehicleStatus}
                onChange={({ detail }) => setVehicleStatus(detail.checked)}
              >
                Active
              </Checkbox>
            </FormField>
            </SpaceBetween>
        </Container>
      </Modal>
    </>
  );
};

export default VehicleDetail;
